import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { Sprite, Text, TextStyle, Texture } from "pixi.js";
import { HBox } from "../../../../common/components/ui/HBox";

export class BaseLoginButton extends ButtonWithScaleAnimation {
    protected icon: Sprite;
    protected buttonText: Text;

    private readonly hBox: HBox;

    public constructor(backgroundTexture: Texture, iconTexture: Texture, text: string) {
        super(backgroundTexture);

        this.hBox = new HBox(10);

        if (iconTexture != null) {
            this.icon = new Sprite(iconTexture);
            this.hBox.addChild(this.icon);
        }

        this.buttonText = new Text(text, new ButtonTextStyle());
        this.hBox.addChild(this.buttonText);

        this.hBox.position.set((this.defaultView.width - this.hBox.width) * 0.5, (this.defaultView.height - this.hBox.height) * 0.5);

        this.defaultView.addChild(this.hBox);
    }
}

class ButtonTextStyle extends TextStyle {
    public constructor() {
        super(
            new TextStyle({
                align: "center",
                fill: "#ffffff",
                fontFamily: GameFont.DEFAULT_FONT,
                fontSize: 42,
                dropShadow: true,
                dropShadowAlpha: 0.5,
                dropShadowAngle: 0.8,
                dropShadowBlur: 3,
                dropShadowDistance: 2,
            })
        );
    }
}
